import React from 'react';
import styles from './deportes.module.css';
import Navbar from '../Navbar/navbar';

const Deportes = () => {
    return (
        <div className={styles.container}>
            <Navbar/>
            <h1 className={styles.deportes}>Deportes</h1>
        </div>
    );
}

export default Deportes;
